export default __webpack_public_path__ + "static/media/circulacion.9549ef3e.png";